export const BEES_GROUP = 'bees'
export const EARLY_ACCESS_GROUP = 'early-access'
